import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChecklistService } from '../../../../pages/checklist/services/checklist.service';

@Component({
  selector: 'app-create-new-template-modal',
  templateUrl: './create-new-template-modal.component.html',
  styleUrls: ['./create-new-template-modal.component.css']
})
export class CreateNewTemplateModalComponent implements OnInit {
  @Input() option: string;
  @Input() mode: string;
  formData: { [key: string]: any } = {};
  templateList: any[] = [];
  templateCategoryIDs: { [key: string]: number } = { "C": 1, "O": -1, "P": -2, "H": -4, "S": -3 };

  constructor(private checklistService: ChecklistService, public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.option == "C") {
      this.checklistService.getChecklistTemplates(this.templateCategoryIDs[this.mode]).then((response: any) => {
        if (response != null) {
          var templates = response;
          var filteredTemplates = [];
          templates.forEach((val: any) => {
            if (this.mode == "O" && val.ChecklistTemplateCatgID == -1) {
                filteredTemplates.push(val);
            }
            else if (this.mode == "P" && val.ChecklistTemplateCatgID != -1 && val.ChecklistTemplateIsActive) {
                filteredTemplates.push(val);
            }
            else if (this.mode == "S" && val.ChecklistTemplateCatgID != -1 && val.ChecklistTemplateIsActive) {
              filteredTemplates.push(val);
            }
            else if (this.mode == "H" && val.ChecklistTemplateCatgID == -4) {
                filteredTemplates.push(val);
            }
            else {
              if (val.ChecklistTemplateCatgID == 1) {
                filteredTemplates.push(val);
              }
            }
          })
          this.templateList = filteredTemplates;
        }
      });
    }
  }

  createClicked() {
    this.activeModal.close(this.formData.newTemplate);
  }

  copyClicked() {
    this.activeModal.close(this.formData);
  }

  cancelClicked() {
    if (this.option == "C") {
      this.activeModal.dismiss();
    }
    else {
      this.activeModal.close("cancel");
    }
  }

}
